import {VocabularyPipe} from '../../shared/vocabulary.pipe';
import { Component, OnInit } from '@angular/core';
import { IBerater } from '../../shared/model/berater.model';
import { BeraterService } from '../../services/berater.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TravelWillingnessPipe } from '../../shared/travel-willingness.pipe';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  LanguageEntry,
  normalizeToLanguageEntries,
  sortLanguageEntries,
} from '../../shared/constants/language-levels';
import { languageDisplayName } from '../../shared/constants/languages';

@Component({
  selector: 'app-text-only.component',
  imports: [DatePipe, TravelWillingnessPipe, TranslatePipe, VocabularyPipe],
  templateUrl: './text-only.component.html',
  styleUrl: './text-only.component.scss',
  standalone: true,
})
export class TextOnlyComponent implements OnInit {
  berater: IBerater;
  languageEntries: LanguageEntry[] = [];

  constructor(
    private beraterService: BeraterService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.beraterService.find(id).subscribe((value) => {
      this.berater = value.body;
      this.languageEntries = sortLanguageEntries(
        normalizeToLanguageEntries(
          this.berater?.personaldaten?.sprachen as LanguageEntry[] | string[] | undefined,
        ),
        (code) => this.languageName(code),
      );
    });
  }

  languageName(code: string): string {
    return languageDisplayName(
      code,
      (key) => this.translateService.instant(key),
      this.translateService.currentLang ?? 'de',
    );
  }
}
